import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { formatMessage } from "devextreme/localization";
import {
  CalculationTableConfig,
  CalculatorOption,
  CalculatorRequest,
  CalculatorUsFormData,
  CalculatorUsFormDropdownValues,
  CalculatorUsPdfRequest,
  TrimSize,
  TrimSizeRuleType,
  TrimSizeValidation,
  TrimSizeValidationResponse,
} from "./calculator-us-formData";
import { UserService } from "../../../services/user.service";
import { CalculatorService } from "../../../services/calculator.service";

import { OrganizationService } from "../../../services/organization.service";
import { compareStringsAlphabeticallyIgnoreCase } from "../../../utils/stringUtils";
import {
  PdfQuoteNumber,
  UsCalculatorResult,
} from "../../../model/calculation/calculationResult";
import { environment } from "../../../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Publisher } from "../../../model/organization/organization";
import { ProduktService } from "../../../services/produkt.service";
import {
  DxDropDownBoxComponent,
  DxFormComponent,
  DxTreeViewComponent,
} from "devextreme-angular";
import { Produkt } from "../../../model/calculation/produkt";
import { Subscription } from "rxjs";
import { OptionService } from "../../../services/option.service";
import { Option } from "../../../model/calculation/option";
import notify from "devextreme/ui/notify";
import { OptionGroup } from "../../../model/calculation/optionGroup";
import { AdditionalSpecificationListComponent } from "./additional-specification-list/additional-specification-list.component";
import { ScalerService } from "../../../services/scaler.service";
import { PriceScaleEntryService } from "../../../services/price-scale-entry.service";
import {
  bindDataSource,
  boardsDataSource,
  caseStyleDataSource,
  endpapersDataSource,
  headFootDataSource,
  packDataSource,
  paperTextDataSource,
  prepDataSource,
  printTextDataSource,
  proofTextDataSource,
  shipmentDataSource,
} from "./dropDownValues";

@Component({
  selector: "app-calculator-us",
  templateUrl: "./calculator-us.component.html",
  styleUrls: ["./calculator-us.component.scss"],
})
export class CalculatorUsComponent
  implements OnInit, OnDestroy, AfterViewChecked
{
  formatMessage = formatMessage;
  json = JSON;
  @ViewChild(DxFormComponent) form: DxFormComponent;
  @ViewChild(AdditionalSpecificationListComponent)
  additionalSpecificationList: AdditionalSpecificationListComponent;

  @ViewChild("dropDowns", { read: ViewContainerRef })
  dropDownsRef: ViewContainerRef;
  @ViewChild("dropDownContent", { read: TemplateRef })
  dropDownContentRef: TemplateRef<any>;
  @ViewChild("loadIndicator", { read: TemplateRef })
  loadIndicatorRef: TemplateRef<any>;

  // Referenzen für alle TreeView-Komponenten
  @ViewChild("prepTree") prepTree: DxTreeViewComponent;
  @ViewChild("proofTree") proofTree: DxTreeViewComponent;
  @ViewChild("printTree") printTree: DxTreeViewComponent;
  @ViewChild("bindTree") bindTree: DxTreeViewComponent;
  @ViewChild("caseStyleTree") caseStyleTree: DxTreeViewComponent;
  @ViewChild("boardsTree") boardsTree: DxTreeViewComponent;
  @ViewChild("endpapersTree") endpapersTree: DxTreeViewComponent;
  @ViewChild("headFootTree") headFootTree: DxTreeViewComponent;
  @ViewChild("packTree") packTree: DxTreeViewComponent;
  @ViewChild("shipmentTree") shipmentTree: DxTreeViewComponent;

  @ViewChild("proofTextDropdown") proofTextDropdown: DxDropDownBoxComponent;

  prepDataSource = prepDataSource;
  proofTextDataSource = proofTextDataSource;
  paperTextDataSource = paperTextDataSource;
  printTextDataSource = printTextDataSource;
  bindDataSource = bindDataSource;
  caseStyleDataSource = caseStyleDataSource;
  shipmentDataSource = shipmentDataSource;
  packDataSource = packDataSource;
  headFootDataSource = headFootDataSource;
  endpapersDataSource = endpapersDataSource;
  boardsDataSource = boardsDataSource;

  prepWidth: number = 3;
  paperTextWidth: number = 3;
  proofTextWidth: number = 3;
  printTextWidth: number = 3;
  bindWidth: number = 3;
  caseStyleWidth: number = 3;
  packWidth: number = 3;
  shipmentWidth: number = 3;
  headFootWidth: number = 3;
  endpapersWidth: number = 3;
  boardsWidth: number = 3;

  calculatorUsFormDropdownValues = new CalculatorUsFormDropdownValues();
  calculationData: CalculatorUsFormData = <CalculatorUsFormData>{};
  collectedAdditionalInformation = {
    prep: null,
    paperText: null,
    proofText: null,
    printText: null,
    bind: null,
    caseStyle: null,
    pack: null,
    shipment: null,
    headFoot: null,
    endpapers: null,
    boards: null,
  };
  organizations: Publisher[];
  selectedPublisher: Publisher;
  products: Produkt[];
  selectedProduct: Produkt;

  calculationResponseSubscription: Subscription;
  calculationResponse: UsCalculatorResult;
  calculationTableConfig: CalculationTableConfig = new CalculationTableConfig(
    false,
    false,
    false
  );
  quantities: number[];

  usedCartonPackOption: Option | any;
  usedCartonPackOptionGroup: any;
  usedCartonCalculatorOption: CalculatorOption;
  selectedCartonPack: string;

  allMappingProperties: Option[];

  showAdditionalSpecifications: boolean;
  additionalOptionGroups: OptionGroup[];
  additioalCalculatorOptions: CalculatorOption[];
  additionalSpecButtonDisabled: boolean = true;

  responseAncillaryGroupTypes: any;

  scalerLabelUrl = `${environment.scalerLabelUrl}`;

  pageDropdownDataSource: number[];

  // Width Height Validation variables
  widthValidationMessage = "";
  heightValidationMessage = "";
  trimSizeValidation: TrimSizeValidationResponse;
  isProductSelected = false;
  constructor(
    public calculatorService: CalculatorService,
    private userService: UserService,
    private produktService: ProduktService,
    private organizationService: OrganizationService,
    private http: HttpClient,
    private optionService: OptionService,
    private scalerService: ScalerService,
    private priceScaleService: PriceScaleEntryService,
    private cd: ChangeDetectorRef
  ) {
    this.displayValueFormatter = this.displayValueFormatter.bind(this);
    this.publisherSelected = this.publisherSelected.bind(this);
    this.productSelected = this.productSelected.bind(this);
    this.resetAutoFilledValues = this.resetAutoFilledValues.bind(this);
    this.validateWidth = this.validateWidth.bind(this);
    this.validateHeight = this.validateHeight.bind(this);

    this.calculationResponseSubscription = this.calculatorService
      .getCalculationResponse()
      .subscribe((response) => {
        this.calculationResponse = response;
      });
  }

  ngAfterViewChecked() {
    this.cd.detectChanges();
  }

  ngOnDestroy(): void {
    this.calculationResponseSubscription.unsubscribe();
  }

  ngOnInit(): void {
    this.organizationService.findAllPublisher().subscribe((org) => {
      if (org) {
        org.sort((a, b) =>
          compareStringsAlphabeticallyIgnoreCase(a.displayName, b.displayName)
        );
        if (org.length == 1) this.selectedPublisher = org[0];
        this.organizations = org;
      }
    });
  }

  getTodaysDate() {
    return new Date().toLocaleDateString("en-US");
  }

  publisherSelected($event: any) {
    this.resetAutoFilledValues();
    // this.selectedProduct = undefined throws error
    this.setProduct(undefined);
    this.selectedPublisher = $event.value;
    this.calculatorService
      .getPublisherByIdNoProduct(this.selectedPublisher.id)
      .subscribe((publisher) => {
        if (publisher?.preislistenKatalog?.produktList) {
          this.products = [...publisher.preislistenKatalog.produktList];
        }
      });
  }

  productSelected($event: any) {
    let formData = this.form?.instance?.option("formData");
    formData.pressMethod = undefined;
    formData.binding = undefined;

    if ($event.value) {
      /*
      this.dropDownsRef.clear();
      this.dropDownsRef.createEmbeddedView(this.loadIndicatorRef);
      */
      // reset values if product changes
      if ($event.previousValue != $event.value) {
        this.resetAutoFilledValues();
      }
      this.produktService
        .getUsaProduct($event.value.id)
        .subscribe((product) => {
          if (product) {
            this.setBinding(product);
            formData.edition = product.edition;
            formData.reprint = product.reprint;
            formData.width = product.width;
            formData.height = product.height;
            this.calculationData.trimSizeGroup =
              product.width + " x " + product.height;
            //Product.twoTitles is boolean but request needs Integer
            this.calculationData.numberOfTitles = product.twoTitles ? 2 : 1;
          }
        });

      this.optionService
        .findOptionGroupsByPreislistenKatalog(
          this.selectedPublisher.preislistenKatalog!
        )
        .subscribe((optionGroups) => {
          this.usedCartonPackOptionGroup = optionGroups.find(
            (optionGroup) =>
              optionGroup.groupName == "Cartoning/Palletizing" ||
              optionGroup.groupName == "Cartons/Cartoning"
          );
          if (this.usedCartonPackOptionGroup) {
            this.optionService
              .findOptionsByOptionGroup(this.usedCartonPackOptionGroup)
              .subscribe((options) => {
                if (options) {
                  const foundOption = options.find((option) => {
                    return (
                      option &&
                      option?.associatedProducts.includes(
                        this.selectedProduct.id
                      ) &&
                      !option.hideInFrontend
                    );
                  });
                  if (foundOption) {
                    this.usedCartonPackOption = { ...foundOption };
                  } else {
                    this.displayError(
                      "calculator.calculation.us.cartonpackoption.notfound",
                      this.selectedProduct.name
                    );
                  }
                }
                /*
                setTimeout(() => {
                  this.cd.detectChanges();
                  this.dropDownsRef.clear();
                  this.dropDownsRef.createEmbeddedView(this.dropDownContentRef);
                }, 10);*/
              });
          } else {
            this.displayError(
              "calculator.calculation.us.optiongroup.notfound",
              this.selectedPublisher.name
            );
          }

          this.additionalOptionGroups = optionGroups.filter((optionGroup) => {
            return (
              optionGroup.groupName != "Cartoning/Palletizing" &&
              optionGroup.groupName != "Cartons/Cartoning"
            );
          });
        });
      this.optionService
        .getOptionsByPreislistenKatalog(
          this.selectedPublisher.preislistenKatalog!
        )
        .subscribe((options) => {
          if (options) {
            this.allMappingProperties = [...options];
          }
        });

      this.priceScaleService
        .findAllPagesInPriceScaleByProductId(this.selectedProduct.id)
        .subscribe((pages) => {
          const pageCopy = [...pages];
          this.pageDropdownDataSource = pageCopy.sort((a, b) => a - b);
        });
      this.getTrimSizeValidations();
    } else {
      /*
      this.cd.detectChanges();
      this.dropDownsRef.clear();
      this.dropDownsRef.createEmbeddedView(this.dropDownContentRef);
      */
    }
  }

  calculate() {
    if (!this.form?.instance.validate().isValid) {
      return;
    }

    this.handleCartonOptionAsOTP();

    this.calculationData.selectedOptions = this.additioalCalculatorOptions
      ? [this.usedCartonCalculatorOption, ...this.additioalCalculatorOptions]
      : [this.usedCartonCalculatorOption];

    const calculationDataCopy = { ...this.calculationData };

    const calculationRequest: CalculatorRequest = new CalculatorRequest(
      calculationDataCopy,
      this.selectedPublisher.id
    );

    console.log(calculationRequest);

    this.http
      .post<UsCalculatorResult>(
        `${environment.baseUrl}/api/calculator/us/calculate`,
        calculationRequest // Daten der Calculation
      )
      .toPromise()
      .then((data) => {
        this.calculatorService.sendCalculationResponse(data);
        // When status success
        if (data.status === "success") {
          // Then exclude 0 Values
          // IMPORTANT: Only enter edit-Response if success -> else Request 400 Error
          this.http
            .post<UsCalculatorResult>(
              `${environment.baseUrl}/api/calculator/us/edit-response`,
              data // daten der response
            )
            .subscribe((data) => {
              this.calculatorService.sendCalculationResponse(data);
              this.prepareResponseTable(data);

              // Quantity Array for the table headline
              this.quantities = [];
              this.quantities = JSON.parse(
                JSON.stringify(this.calculationData.quantity)
              );
            });
        }
        // when error
        else {
          this.quantities = [];
          this.calculationTableConfig = new CalculationTableConfig(
            false,
            false,
            false
          );
        }
      });
  }

  private prepareResponseTable(data: UsCalculatorResult) {
    let calcData = data.data;
    this.calculationTableConfig.responseSuccessful = true;

    this.responseAncillaryGroupTypes = data.data.ancillaryItemGroupList[0]
      .ancillaryItemList!.filter(
        (ancillaryItem) =>
          ancillaryItem.invoiceItemAncillaryType == "SUMMARY" &&
          ancillaryItem.invoiceItemAncillaryCode != "SUMMARY_TOTAL"
      )
      .map((value) => {
        return value.ancillaryTypeName == "OPTION_GROUP"
          ? { value: value.ancillaryTypeName, name: value.ancillaryCodeName }
          : {
              value: value.ancillaryTypeName,
              name: formatMessage(
                "calculator.calculation.us.response.headLineText." +
                  value.ancillaryTypeName.toLowerCase()
              ),
            };
      });

    // Überprüfung für das zweite Objekt in ancillaryItemGroupList
    this.calculationTableConfig.showSecondCol = !!(
      calcData.ancillaryItemGroupList &&
      calcData.ancillaryItemGroupList[1] &&
      calcData.ancillaryItemGroupList[1].ancillaryItemList &&
      calcData.ancillaryItemGroupList[1].ancillaryItemList.length > 0
    );

    // Überprüfung für das dritte Objekt in ancillaryItemGroupList
    this.calculationTableConfig.showThirdCol = !!(
      calcData.ancillaryItemGroupList &&
      calcData.ancillaryItemGroupList[2] &&
      calcData.ancillaryItemGroupList[2].ancillaryItemList &&
      calcData.ancillaryItemGroupList[2].ancillaryItemList.length > 0
    );
  }

  setProduct(product) {
    this.selectedProduct = product;
  }
  private resetAutoFilledValues() {
    if (this.selectedProduct) {
      const formData = this.form?.instance?.option("formData");
      formData.edition = undefined;
      formData.binding = undefined;
      formData.reprint = undefined;
      formData.pressMethod = undefined;
      formData.width = undefined;
      formData.height = undefined;
      formData.trimSizeGroup = undefined;
      this.usedCartonPackOption = undefined;
      this.selectedCartonPack = "";
      this.calculationData.selectedOptions = [];
      this.additionalOptionGroups = [];
    }
  }

  // TODO : Match MM Rules with Backend Trimsize rules

  private setBinding(product: Produkt) {
    const form = this.form?.instance?.option("formData");
    //Mass Market
    if (product.edition === "MM") {
      //Rack
      if (
        product.width == 4.125 &&
        (product.height == 6.75 || product.height == 6.625)
      ) {
        form.binding = "MMR";
      }
      //Premium
      if (product.width == 4.125 && product.height == 7.5) {
        form.binding = "MMP";
      }
      //Digest
      if (product.width == 5.1875 && product.height == 7.625) {
        form.binding = "MMD";
      }
      this.setPressMetod(product.produktType);
    } else {
      //Trade Market
      form.binding = product.produktType;
    }
  }

  private setPressMetod(produktType: string) {
    this.calculationData.pressMethod = produktType;
  }

  onCartonPackSelected(event: any) {
    if (event && this.usedCartonPackOption) {
      const mappingProperties = this.allMappingProperties.find(
        (option) => option.id == this.usedCartonPackOption.id
      )?.optionMappingProperties;
      if (mappingProperties) {
        this.usedCartonCalculatorOption = {
          optionId: this.usedCartonPackOption.id,
          optionValue: event.selectedItem.replace(/\D/g, ""),
          specification: mappingProperties.specification,
          wildcard: mappingProperties.wildcard,
        };
      }
    }
  }

  displayError(key: string, addition?: string) {
    if (addition) {
      notify(
        {
          message: formatMessage(key, addition),
          type: "error",
          displayName: 3500,
        },
        { position: "bottom center", direction: "up-stack" }
      );
    } else {
      notify(
        {
          message: formatMessage(key),
          type: "error",
          displayName: 3500,
        },
        { position: "bottom center", direction: "up-stack" }
      );
    }
  }

  onCartonPackFocusIn() {
    if (!this.usedCartonPackOptionGroup && this.selectedProduct) {
      this.displayError(
        "calculator.calculation.us.optiongroup.notfound",
        this.selectedPublisher.name
      );
    }
    if (
      !this.usedCartonPackOption &&
      this.selectedProduct &&
      this.usedCartonPackOptionGroup &&
      this.usedCartonPackOption.optionType == "CATONS"
    ) {
      this.displayError(
        "calculator.calculation.us.cartonpackoption.notfound",
        this.selectedProduct.name
      );
    }
  }

  submitOptionen() {
    if (this.additionalSpecificationList.checkIfInputMissing()) {
      return;
    }

    this.showAdditionalSpecifications = false;
    let selectedOptions: Option[] = [];
    this.additioalCalculatorOptions = [];
    this.additionalSpecificationList.list.selectedItems.forEach(
      (group) => (selectedOptions = [...selectedOptions, ...group.items])
    );

    console.log(selectedOptions);
    selectedOptions.forEach((option) => {
      // TODO: why is there a mapping property check??
      const mappingProperties = this.allMappingProperties.find(
        (mappingOption) => option.id == mappingOption.id
      )?.optionMappingProperties;
      if (mappingProperties) {
        const calculatorOption: CalculatorOption = {
          optionId: option.id,
          optionValue: option.userInput,
          specification: mappingProperties.specification,
          wildcard: mappingProperties.wildcard,
        };

        this.additioalCalculatorOptions.push(calculatorOption);
      }
    });
  }

  onSelectOptions($event: Option[]) {
    this.showAdditionalSpecifications = false;
  }

  onAddSpecButtonSelected() {
    this.showAdditionalSpecifications = true;
  }

  private handleCartonOptionAsOTP() {
    if (this.usedCartonPackOption.optionType == "ONE_TIME_PRICES") {
      const mappingProperties = this.allMappingProperties.find(
        (option) => option.id == this.usedCartonPackOption.id
      )?.optionMappingProperties;
      if (mappingProperties) {
        this.usedCartonCalculatorOption = {
          optionId: this.usedCartonPackOption.id,
          optionValue: this.calculationData.quantity[0],
          specification: mappingProperties.specification,
          wildcard: mappingProperties.wildcard,
        };
      }
    }
  }

  onFormFieldChanged() {
    const form = this.form?.instance?.option("formData");
    if (form?.quantity) {
      this.additionalSpecButtonDisabled = !(
        this.selectedProduct &&
        !(form?.quantity[0] == undefined || form?.quantity[0] == "")
      );
    }
  }

  private async preparePdfRequestData(): Promise<CalculatorUsPdfRequest> {
    const quoteNumber: string = await this.getQuoteNumber();
    const formData = this.form?.instance?.option("formData");

    let pdfRequestData: CalculatorUsPdfRequest = {
      ...this.calculationResponse,
      language: "en",
      labelUrl: this.scalerLabelUrl,
      pdfFooterLine1: formatMessage("calculator.pdf.general.pdfFooterLine1"),
      pdfFooterLine2: formatMessage("calculator.pdf.general.pdfFooterLine2"),
      pdfVersion: formatMessage("calculator.pdf.general.pdfVersion"),
      generalInformation: {
        author: formData.author,
        customer: this.selectedPublisher.displayName,
        customerContact: formData.customerContact,
        date: new Date().toLocaleDateString("en-US"),
        quoteNumber: quoteNumber,
        bpgContact: formData.bpgContact,
        bpgEmail: formatMessage(
          "calculator.pdf.generalInformation.bpgEmailValue"
        ),
      },
      jobSpecification: {
        title: formData.title,
        quantity: Object.values(formData.quantity).map(Number),
        trimSize: formData.width + " x " + formData.height,
        pages: formData.pages,
        prep: formData.prep, //
        proofs: formData.proofText, //
        plates: formData.plates, //
        paper: formData.paperText,
        print: formData.printText, //
        bind: formData.bind, //
        pack: this.selectedCartonPack.replace(
          formatMessage("calculator.pdf.general.selectedCartonPack.value"),
          formatMessage(
            "calculator.pdf.general.selectedCartonPack.replaceValue"
          )
        ),
      },
    };

    return pdfRequestData;
  }

  private getQuoteNumber(): Promise<string> {
    return this.http
      .get<PdfQuoteNumber>(
        `${environment.baseUrl}/api/calculator/us/quote-number`
      )
      .toPromise()
      .then((quoteNumberWrapper) => quoteNumberWrapper.quoteNumber);
  }

  async downloadPdf() {
    // calculate before download
    try {
      // Wait for the calculationResponse to update
      // before proceeding to the next step
      await this.waitForCalculationResponse();

      //send to scaler
      let request = await this.preparePdfRequestData();
      this.scalerService.downloadUsCalculatorPdf(
        "calculation",
        JSON.stringify(request)
      );
    } catch (error) {
      console.error("Error during PDF download:", error);
    }
  }

  private waitForCalculationResponse(): Promise<void> {
    return new Promise((resolve) => {
      // Set up a subscription to catch the calculation response event
      const subscription = this.calculatorService
        .getCalculationResponse()
        .subscribe((response) => {
          if (response.status === "success") {
            resolve(response);
            subscription.unsubscribe();
          }
        });
      // Trigger the calculate method
      this.calculate();
    });
  }

  getTrimSizeValidations() {
    const param = new HttpParams().set("productId", this.selectedProduct.id);
    this.http
      .get<TrimSizeValidationResponse>(
        `${environment.baseUrl}/api/calculator/us/validate-trim-size/${this.selectedPublisher.id}`,
        { params: param }
      )
      .toPromise()
      .then((response) => {
        this.trimSizeValidation = response;
      });
  }

  validateWidth(): boolean {
    this.widthValidationMessage = this.getValidationMessage(
      this.trimSizeValidation?.width
    );
    return this.compareTrimSizeRuleToInput(
      Number(this.calculationData.width),
      this.trimSizeValidation?.width
    );
  }

  validateHeight(): boolean {
    this.heightValidationMessage = this.getValidationMessage(
      this.trimSizeValidation?.height
    );
    return this.compareTrimSizeRuleToInput(
      Number(this.calculationData.height),
      this.trimSizeValidation?.height
    );
  }

  compareTrimSizeRuleToInput(
    userInput: number,
    validator: TrimSizeValidation
  ): boolean {
    switch (validator?.validationRule) {
      case TrimSizeRuleType.HEIGHT_GREATER_THAN_OR_EQUAL_TO:
      case TrimSizeRuleType.WIDTH_GREATER_THAN_OR_EQUAL_TO:
        return userInput >= validator.comparer;
      case TrimSizeRuleType.HEIGHT_LESS_THAN_OR_EQUAL_TO:
      case TrimSizeRuleType.WIDTH_LESS_THAN_OR_EQUAL_TO:
        return userInput <= validator.comparer;
      case TrimSizeRuleType.HEIGHT_GREATER_THAN:
      case TrimSizeRuleType.WIDTH_GREATER_THAN:
        return userInput > validator.comparer;
      case TrimSizeRuleType.WIDTH_EQUAL_TO:
      case TrimSizeRuleType.HEIGHT_EQUAL_TO:
        return userInput == validator.comparer;
      case TrimSizeRuleType.HEIGHT_LESS_THAN:
      case TrimSizeRuleType.WIDTH_LESS_THAN:
        return userInput < validator.comparer;
      default:
        return false;
    }
  }

  getValidationMessage(validator: TrimSizeValidation): string {
    switch (validator?.validationRule) {
      case TrimSizeRuleType.HEIGHT_GREATER_THAN_OR_EQUAL_TO:
      case TrimSizeRuleType.WIDTH_GREATER_THAN_OR_EQUAL_TO:
      case TrimSizeRuleType.HEIGHT_LESS_THAN_OR_EQUAL_TO:
      case TrimSizeRuleType.WIDTH_LESS_THAN_OR_EQUAL_TO:
      case TrimSizeRuleType.HEIGHT_GREATER_THAN:
      case TrimSizeRuleType.WIDTH_GREATER_THAN:
      case TrimSizeRuleType.WIDTH_EQUAL_TO:
      case TrimSizeRuleType.HEIGHT_EQUAL_TO:
      case TrimSizeRuleType.HEIGHT_LESS_THAN:
      case TrimSizeRuleType.WIDTH_LESS_THAN:
        return formatMessage(
          `calculator.calculation.validation.${validator.validationRule}`,
          validator.comparer.toString()
        );
    }
  }

  onDropDownBoxValueChanged(e, field) {
    console.log(this.calculationData[field]);

    if (!e.value) {
      this[field + "Tree"]?.instance.unselectAll();
    } else {
      this[field + "Tree"]?.instance.selectItem(this.calculationData[field]);
    }
    console.log(field);
    console.log(this.collectedAdditionalInformation);
    console.log(e);
    const currentValue = this.getSelectedValue(e, field);
    const currentWidth = this[field + "Width"];
    this.collectedAdditionalInformation[field] = this.getSelectedValue(
      e,
      field
    );
    console.log(this.calculationData);
    console.log(this.collectedAdditionalInformation);
  }

  private getSelectedValue(valueChangeEvent, field) {
    const currentDatasource = this[field + "DataSource"];
    console.log(currentDatasource);
    console.log(valueChangeEvent);

    const targetId = this.calculationData[field][0]; // Get the current id
    if (!targetId) {
      console.warn(`No id found in calculationData for field: ${field}`);
      return null;
    }

    // Iterate over the currentDatasource to find the matching object
    for (const item of currentDatasource) {
      if (item.id === targetId) {
        return item; // Return the matching object
      }
    }

    console.warn(`No matching object found for id: ${targetId}`);
    return null; // Return null if no match is found
  }

  displayValueFormatter(value) {
    if (!value) return "";
    return value;
  }

  // Helper function to get the parent value
  getParentItem(value: any): any {
    return (
      this.proofTextDataSource.find(
        (parent) => parent.id === value.categoryId
      ) || null
    );
  }

  onTreeViewSelectionChanged(e, field) {
    const selectedNode = e.node;

    if (selectedNode.itemData.isGroup) {
      e.component.unselectItem(selectedNode.key); // Deselect falls Gruppe
      return;
    }

    this.calculationData[field] = e.component.getSelectedNodeKeys() || null;
  }

  onItemClick($event: any, type: string) {
    if ($event.value) console.log(type);
    console.log($event);
    let clickedItem = $event.itemData;

    // check if clicked item has no sub items
    if (!clickedItem.items) {
      console.log(clickedItem.text);
      switch (type) {
        case "prep":
          this.calculationData.prep = clickedItem.text;
          this.prepWidth = 1;
          break;
        case "proofText":
          this.calculationData.proofText = clickedItem.text;
          this.proofTextWidth = 1;
          break;
        case "printText":
          this.calculationData.printText = clickedItem.text;
          this.printTextWidth = 1;
          break;
        case "bind":
          this.calculationData.bind = clickedItem.text;
          this.bindWidth = 1;
          break;
        default:
          break;
      }
      console.log(this.calculationData);
    }
  }

  protected readonly setTimeout = setTimeout;
}
